import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Banner.module.css';
// Importar animaciones globales para que los @keyframes estén disponibles
import '../../styles/animations.module.css';

/**
 * Banner Component - TECNILAND Hero Section
 * DESKTOP-FIRST: Animaciones optimizadas para 1920px+
 * MOBILE: Partículas estáticas moradas sin animaciones
 * Sin hacks de JavaScript - CSS puro con CSS Modules
 */
function Banner() {
  const navigate = useNavigate();
  const [particles, setParticles] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Detectar cambios de viewport con debounce para evitar renders excesivos
  useEffect(() => {
    let debounceTimer;
    const handleResize = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        setIsMobile(window.innerWidth <= 768);
      }, 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(debounceTimer);
    };
  }, []);

  useEffect(() => {
    // Generar partículas - mismo tipo en móvil y desktop pero con diferente cantidad
    const particleCount = isMobile ? 25 : 50; // Menos partículas en móvil para performance
    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 2,
      duration: isMobile ? 4 + Math.random() * 2 : 3 + Math.random() * 2, // Más lentas en móvil
    }));
    setParticles(newParticles);
  }, [isMobile]);

  return (
    <section className={styles.banner}>
      {/* Partículas de fondo - animadas tanto en móvil como desktop */}
      <div className={styles.particles}>
        {particles.map((particle) => (
          <div
            key={particle.id}
            className={styles.particle}
            style={{
              left: `${particle.left}%`,
              top: `${particle.top}%`,
              '--particle-delay': `${particle.delay}s`,
              '--particle-duration': `${particle.duration}s`,
            }}
          ></div>
        ))}
      </div>

      {/* Contenido principal con wrapper para animación de flotación */}
      <div className={styles.bannerContentWrapper}>
        <div className={styles.bannerContent}>
          <h1 className={styles.bannerTitle}>
            Bienvenido al
            <br />
            <span className={styles.highlight}>Multiverso</span>
          </h1>
          <p className={styles.bannerSubtitle} translate="no">TECNILAND</p>
          <p className={styles.bannerDescription}>
            Un universo Minecraft inmersivo, épico y completamente personalizado
          </p>

          {/* CTA */}
          <div className={styles.bannerCta}>
            <button 
              className={styles.btnPrimary}
              onClick={() => navigate('/server')}
            >
              Muy Pronto
            </button>
            <button 
              className={styles.btnSecondary}
              onClick={() => {
                const introSection = document.getElementById('intro');
                if (introSection) {
                  introSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Explorar
            </button>
          </div>

          {/* Scroll indicator */}
          <div className={styles.scrollIndicator}>
            <span>↓ Desplázate ↓</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
